<template>
  <div>
    <SeaZone/>
    <CardSearch :page="'monitering'"/>
    <Map/>
  </div>
</template>

<script>
import gmapsInit from "@/gmap/gmaps";
import moment from "moment-timezone";
import Map from "./components/Map.vue";
import SeaZone from "./components/SeaZone.vue";
import CardSearch from "./components/CardSearch.vue";

export default {
   components: {
    SeaZone,
    CardSearch,
    Map,
  },
    data() {
    return {

    };
  },
  created() {
  },
  methods: {

  },

}
</script>

<style scoped>
#map {
  position: relative;
  width: 100%;
  height: 100%;
}
#map-view {
  width: 100%;
  height: 100%;
}
</style>